// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppointmentsCalendarController from "./appointments_calendar_controller"
application.register("appointments-calendar", AppointmentsCalendarController)

import DependentSelectController from "./dependent_select_controller"
application.register("dependent-select", DependentSelectController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultistepformController from "./multistepform_controller"
application.register("multistepform", MultistepformController)

import NavbarShadowOnScrollController from "./navbar_shadow_on_scroll_controller"
application.register("navbar-shadow-on-scroll", NavbarShadowOnScrollController)

import NavbarVerticalToggleController from "./navbar_vertical_toggle_controller"
application.register("navbar-vertical-toggle", NavbarVerticalToggleController)

import ThemeSwitcherController from "./theme_switcher_controller"
application.register("theme-switcher", ThemeSwitcherController)

import TimeslotsCalendarController from "./timeslots_calendar_controller"
application.register("timeslots-calendar", TimeslotsCalendarController)

import TimeslotsController from "./timeslots_controller"
application.register("timeslots", TimeslotsController)
